import { useEffect } from 'react'
import BottomSheetContent from '../../BottomSheetContent'
import { trackEvent } from '../../../../utils/appBridge'
import { EventNames } from '../../../../types/misc.types'
import RenderHTML from '../../../ui-components/RenderHTML'
import { PrimaryButton } from '../../../execution/PrimaryButton'
import { WarningIcon } from '../PaymentNotCompletedBottomSheet'

export const AutopayMandatoryBottomSheet = ({
  onDismiss,
  onAddAutopay,
  onExitAnyway,
  ScreenName
}: {
  onDismiss: () => void
  onAddAutopay: () => void
  onExitAnyway: () => void
  ScreenName: string
}) => {
  const heading = 'Autopay is mandatory for SIPs'

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  return (
    <BottomSheetContent
      heading=''
      headingComponent={
        <div className='flex flex-col items-start px-5 mb-2 pt-2'>
          <div className='mb-4'>
            <RenderHTML innerHTMLText={WarningIcon} />
          </div>
          <h2 className='text-[22px] font-[500] text-left'>{heading}</h2>
        </div>
      }
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500]'
      bottomSheetBodyClassName='!px-0 !pb-3'
      bottomSheetCtas={
        <div className='flex flex-col gap-3'>
          <PrimaryButton
            onClick={onAddAutopay}
            label='Add Autopay'
            primaryButtonClassName='!h-14 !text-[16px] !rounded-xl'
          />
          <button
            onClick={onExitAnyway}
            className='w-full py-2 px-4 text-[#232323] font-medium rounded-xl h-14 outline-none focus:outline-none bg-transparent'
          >
            Exit anyway
          </button>
        </div>
      }
    >
      <div className='flex flex-col items-start'>
        <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%] text-left px-5 pb-5 pt-0'>
          Autopay is required so that your SIPs are debited automatically every month.
        </div>
        <div className='flex items-center gap-3 px-5 pb-1'>
          <div className='w-[2px] h-[22px] bg-[#E77464] flex-shrink-0 mt-[2px] rounded-[12px]' />
          <div className='text-[#E77464] text-[14px] font-[500] leading-[150%] text-left'>
            SIP payments will fail if Autopay isn't added.
          </div>
        </div>
      </div>
    </BottomSheetContent>
  )
}
